import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { AuditGrade } from '../types';

export const getAuditGradeForMe = async (): Promise<AuditGrade> => {
  const fetchResponse = await fetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-grade`, {
    method: 'GET',
    headers: {
      authenticate: localStorage.getItem('accessToken') || '',
    },
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditGrade;
  return response;
};
